module.exports = __webpack_public_path__ + "static/media/gift-aid.b0ebd3e9.svg";